module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"product_option":"Product option","positive":"Satisfied","neutral":"Neutral","negative":"Could be better","expand_review":"Show more","collapse_review":"Show less"}}')
  delete Component.options._Ctor
}
